import { getContext, setContext } from 'svelte';
import type { ShareableContainer } from '$lib/container/shareableContainer.js';

const symbol = Symbol('container key from context');

export function getContainer(): ShareableContainer {
    try {
        return getContext(symbol);
    } catch {
        throw new Error('ShareableContainer must set in context with setContainer');
    }
}

export function setContainer(container: ShareableContainer) {
    setContext(symbol, container);
}
